export enum TipoRespostaNegociacaoPedido {
    "ACEITA" = "ACEITA",
    "RECUSADA" = "RECUSADA",
    "CONTRAPROPOSTA" = "CONTRAPROPOSTA"
}